import styled from 'styled-components/macro';

export const BackLink = styled('a')<any>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.DeepBlue};
  font-weight: 600;
  transition: ${({ theme }) =>
    `${theme.transitionDuration} ${theme.timingFunction} all`};

  > svg {
    margin-right: 0.75em;
    color: ${({ theme }) => theme.AccentGreen};
  }
  &:focus,
  &:active {
    background: ${({ theme }) => theme.Sand};
    color: ${({ theme }) => theme.AccentGreen};
  }
  &:hover {
    color: ${({ theme }) => theme.AccentGreen};
    cursor: pointer;
  }
`;
